import { useEffect } from 'react';
import { listenPontosItinerario } from '../../channels/pontosItinerarioChannel';
import { usePontosItinerarioStore } from '../../stores/usePontosItinerarioStore';

export function usePontosItinerarioChannel() {

    useEffect(() => {

        const unsubscribe = listenPontosItinerario(({
            tipo,
            payload
        }) => {

            const store = usePontosItinerarioStore.getState();

            switch (tipo) {

                case 'pontos-iti-sync':

                    store.setPontosBatch(
                        payload.pontos,
                        false
                    );

                    break;

                case 'pontos-iti-upsert':

                    store.upsertPonto(
                        payload,
                        false
                    );

                    break;

                case 'pontos-iti-delete':

                    store.deletePonto(
                        payload,
                        false
                    );

                    break;

                case 'pontos-iti-codigo-delete':

                    store.deletePontosByCodigo(
                        payload,
                        false
                    );

                    break;

                case 'pontos-iti-snapshot':

                    store.setPontosSnapshot(
                        payload.pontos
                    );

                    break;

                case 'pontos-iti-reset':

                    store.resetPontos(false);

                    break;

                default:
                    break;
            }

        });

        return unsubscribe;

    }, []);

}